import { DELETE_ORDER } from '../constants';

const deleteOrder = (state, action) => {
    if (state === undefined) {
        return {
            data: {},
            loading: false,
            error: null,
            success: false,
        };
    }

    switch (action.type) {
        case DELETE_ORDER.FETCH_DELETE_ORDER_REQUEST:
            return {
                data: action.payload,
                loading: true,
                error: null,
                success: false,
            };

        case DELETE_ORDER.FETCH_DELETE_ORDER_SUCCESS:
            return {
                data: {},
                loading: false,
                error: null,
                success: true,
            };

        case DELETE_ORDER.FETCH_DELETE_ORDER_FAILURE:
            return {
                data: action.payload,
                loading: false,
                error: true,
                success: false,
            };

        default:
            return state;
    }
};

export default deleteOrder;
